import React, { useEffect, useMemo, useState } from 'react'

import Package from './Package'
import Carousel from '../../../Carousel'

import DesktopPackages from './DesktopPackages'
import useDetectDevice from '../../../../hooks/useDetectDevice'
import { isProductionBuild } from '../../../../helpers/general'
import MobilePackages from './MobilePackages'

function DesignPicker({
  defaultPackage,
  className = '',
  onPackageSelected,
  selectedPackage,
  selectedLine,
  selectedLevel,
  packages,
  minimal,
  ...props
}) {
  const { isDesktop } = useDetectDevice()

  function isActive(pack) {
    return selectedPackage && pack.id === selectedPackage.id
  }

  function onPackageClicked(pack) {
    onPackageSelected(pack)
  }

  const [carousel, setCarousel] = useState()

  return (
    <div className={`lg:h-[52px] shadow flex items-center lg:overflow-y-hidden ${className}`} id="design-picker">
      {isDesktop && (
        <DesktopPackages
          minimal={minimal}
          isPackageActive={isActive}
          packages={packages}
          onPackageClicked={(pack) => onPackageClicked(pack)}
        />
      )}
      <div className="lg:hidden w-screen overflow-hidden" id="swiper-package-mobile" key={selectedLine.id}>
        <MobilePackages
          minimal={minimal}
          carousel={carousel}
          packages={packages}
          onPackageClicked={onPackageClicked}
          isActive={isActive}
        />
      </div>
    </div>
  )
}

export default DesignPicker
